// extracted by mini-css-extract-plugin
export var closeButton = "_lx-1";
export var closeX = "_lx-3";
export var container = "_lx-0";
export var image = "_lx-2";